import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box } from "@mui/material";
import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";

const SMSReport = ({ startDate, endDate, downloadExcel, token }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/reports/smsSummary?startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        // Use the data directly
        const rows = response.data.data.map((row, idx) => ({
          id: idx + 1,
          type: row.type,
          sent: row.sent,
          failed: row.failed,
          sms_count: row.sent - row.failed,
          credits: row.credits,
        }));

        setData(rows);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (startDate && endDate) {
      fetchData();
    }
  }, [startDate, endDate, downloadExcel, token]);

  const columns = [
    {
      field: "type",
      headerName: "Message Type",
      flex: 2,
    },
    {
      field: "sent",
      headerName: "SMS Attempted",
      flex: 1,
      type: "number",
    },
    {
      field: "failed",
      headerName: "Failed",
      flex: 1,
      type: "number",
    },
    {
      field: "sms_count",
      headerName: "Sent",
      flex: 1,
      type: "number",
    },
    {
      field: "credits",
      headerName: "Credits Used",
      flex: 1,
      type: "number",
    },
  ];

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!data || data.length === 0) return <h3>No Data Available</h3>;

  return (
    <Box sx={{ height: 600, width: "100%", marginTop: 2 }}>
      <DataGridPremium
        rows={data}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newSize) => setPageSize(newSize)}
        slots={{ toolbar: GridToolbar }}
        pageSizeOptions={[5, 10, 15, 20]}
        disableRowSelectionOnClick
        getRowId={(row) => row.id}
      />
    </Box>
  );
};

export default SMSReport;
